// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file. JavaScript code in this file should be added after the last require_* statement.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.
//
//= require jquery
//= require jquery_ujs
// import "@hotwired/turbo-rails"

var app = angular.module("conductor", ["ui.router"])
app
  .run(($rootScope, $http, $state, $window) => {
    $rootScope.iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
    $rootScope.ismobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )

    if (window.location.origin.indexOf("localhost") != -1) {
      $rootScope.isdev = true
      $rootScope.hostname = "localhost:3000"
      $rootScope.hostprefix = "http://localhost:3000"
    } else {
      $rootScope.hostprefix = "https://" + $window.location.hostname
      $rootScope.hostname = $window.location.hostname
      $rootScope.isdev = false
    }

    $rootScope.show_modal = false

    $rootScope.open_modal = (str) => {
      $rootScope.show_modal = str
    }

    $rootScope.close_modal = () => {
      $rootScope.show_modal = false
    }

    $rootScope.try_close_modal = (e) => {
      if (e.target.className.includes("modal_wrapper")) {
        $rootScope.close_modal()
      }
    }
  })
  .config(
    ($httpProvider, $sceProvider, $sceDelegateProvider, $locationProvider) => {
      $httpProvider.defaults.headers.common["X-Requested-With"] =
        "XMLHttpRequest"
      $sceDelegateProvider.resourceUrlWhitelist(["self", "**"])
      $sceProvider.enabled(false)
      $locationProvider.html5Mode(true) //.hashPrefix("#")
    }
  )
app.config(function ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise("/about")
  $stateProvider.state("home", {
    url: "/",
    templateUrl: "/partial/home",
    controller: "homeCtrl",
  })
})
app.controller("homeCtrl", function ($scope, $rootScope) {
  $scope.show = {}
})
app.controller("orderCtrl", function ($scope, $rootScope, $http) {})
app.controller("perfsCtrl", function ($scope, $http) {
  $http.get("/api/perfs").then(
    (r, s) => {
      $scope.perfs = r.data.perfs
    },
    (r, s) => {}
  )
})
app.controller("slidesCtrl", function ($scope) {
  $scope.map_config = {
    fade: false,
    fill: false,
    stroke: false,
    // "fade": true,
    alwaysOn: true,
    neverOn: false,
    //"fill": true,
    //"fillColor": "#ffffff",
    //"fillOpacity": 0.4,
    //"stroke": false,
    //"strokeColor": "#4d0ec0",
    //"strokeOpacity": 1,
    //"strokeWidth": 1,
    shadow: true,
    shadowColor: "#000000",
    shadowOpacity: 0.8,
    shadowRadius: 10,
  }
})
app.directive("text", function ($http) {
  return {
    restrict: "EA",
    scope: { name: "@" },
    templateUrl: "/partial/textwrapper",
    controller: ($scope) => {
      $http.get("/api/text/" + $scope.name).then((d, s) => {
        $scope.text = d.data.text
      })
    },
  }
})
